import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from '../../../../components';
import { FEATURE_FLAGS, ROUTE_TYPE_GUIDED_SELF_HELP } from '../../../../config/constants';
import useClasses from '../../../../hooks/useClasses';
import useRoutes from '../../../../hooks/useRoutes';

const ResetPasswordSuccess = () => {
  const { t } = useTranslation();

  const { buildClass } = useClasses('ResetPassword');
  const { program } = useRoutes();
  const { clients } = useRoutes(ROUTE_TYPE_GUIDED_SELF_HELP);

  const currentDomain = useSelector((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''));
  const buttonClass = buildClass('button');

  return (
    <>
      <div className={buildClass('title')}>
        <h1>{t('pages.reset_password.success.title')}</h1>
      </div>
      <p>{t('pages.reset_password.success.body')}</p>

      {FEATURE_FLAGS.zelfhulp_poh ? (
        <Button href={clients} className={buttonClass}>{t('buttons.to_dashboard')}</Button>
      ) : (
        <Button href={program} className={buttonClass}>{t('buttons.to_program')}</Button>
      )}
    </>
  );
};

export default ResetPasswordSuccess;
